
import {PropType} from "vue";
import PriceDetailsContent from "./PriceDetailsContent.vue";
import {
    MultiplePriceDetailsPopinDto,
    PriceDetailsCashbackDto,
    PriceDetailsCashbackType,
    PriceDetailsDiscountDto
} from "../../components/custom/models/PriceDetailsPopinDto";
import Price from "../../components/ob1/Price.vue";
import {PromotionType} from "../../components/ob1/models/Price";
import {computeCashbackType, computeFinalDiscountType} from "../../utils/PriceDetailsPromotion";

export default {
    name: "MultiplePriceDetailsPopin",
    components: {
        Price,
        PriceDetailsContent,
    },
    props: {
        modalId: {
            type: String,
            required: true,
        },
        priceDetails: {
            type: Object as PropType<MultiplePriceDetailsPopinDto>,
            required: true,
        },
    },
    computed: {
        allDiscounts(): ReadonlyArray<PriceDetailsDiscountDto> {
            return this.priceDetails.offersPriceDetails.flatMap((offerPriceDetails) => offerPriceDetails.discounts);
        },
        allCashbacks(): ReadonlyArray<PriceDetailsCashbackDto> {
            return this.priceDetails.offersPriceDetails.flatMap((offerPriceDetails) => offerPriceDetails.cashbacks);
        },
        cashbackType(): PriceDetailsCashbackType | undefined {
            return computeCashbackType(this.allCashbacks);
        },
        finalDiscountType(): PromotionType | undefined {
            return computeFinalDiscountType(this.allDiscounts, this.allCashbacks);
        },
    },
};
